import { makeFormRequest, makeDeleteRequest, Response } from '../helpers';

import { Photo } from '@/types/common'
interface ImageInterface {
    id: number,
    src: string,
}

// files

type FileType = 'contracts' | 'medical_research';
type FileUpload = {
    file: File,
    title: string,
    typeSlug: FileType,
}

export const uploadFile = async (upload: FileUpload) => {
    const response = await makeFormRequest<Response<{ file: Photo }>>('api/files', upload);

    return response.data.result.file;
}

export const deleteFile = async (id: number) => makeDeleteRequest(`api/files/${id}`);

// images
export const uploadImage = async (upload: File) => {
    const response = await makeFormRequest<Response<{ image: ImageInterface }>>('api/images', { image: upload });

    return response.data.result.image;
}

export const deleteImage = async (id: number) => makeDeleteRequest(`api/images/${id}`);
